import { render, staticRenderFns } from "./DeleteEvent.vue?vue&type=template&id=566d42ed&"
import script from "./DeleteEvent.vue?vue&type=script&lang=js&"
export * from "./DeleteEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports